import { Check } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { isEnglishPath } from '../utils/i18nRoutes';

export default function KeyFacts() {
  const location = useLocation();
  const isEn = isEnglishPath(location.pathname);

  const eyebrow = isEn ? 'At a glance' : 'Auf einen Blick';
  const h2 = isEn ? 'Key facts about working together' : 'Key Facts zur Zusammenarbeit';
  const intro = isEn
    ? 'OptiAI does not work with the classic consulting model of daily rates. Our compensation is based on the success we achieve for your company.'
    : 'OptiAI arbeitet nicht nach dem klassischen Beratermodell mit Tagessätzen. Die Vergütung richtet sich nach dem Erfolg, den wir für Ihr Unternehmen erzielen.';

  const items = isEn
    ? [
        'Success-based: no demonstrable savings, no costs.',
        'Analysis and strategy free of charge: we only share in the success once measures are implemented.',
        'Quickly visible: an AI phone assistant is implemented in four to six weeks.',
        'DACH-wide: based in Vienna, serving Austria, Germany and Switzerland.',
      ]
    : [
        'Erfolgsbasiert vergütet: keine nachweisliche Ersparnis, keine Kosten.',
        'Analyse und Strategie kostenfrei: erst bei umgesetzten Maßnahmen beteiligen wir uns am Erfolg.',
        'Schnell sichtbar: ein KI-Telefonassistent ist in vier bis sechs Wochen umgesetzt.',
        'DACH-weit: Sitz in Wien, Betreuung in Österreich, Deutschland und der Schweiz.',
      ];

  return (
    <section className="py-20 px-6 bg-white dark:bg-gray-900">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <span className="eyebrow">{eyebrow}</span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-dark dark:text-white mt-2 mb-4">
            {h2}
          </h2>
          <p className="text-lg text-muted dark:text-gray-300 max-w-3xl mx-auto leading-relaxed">
            {intro}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {items.map((item) => (
            <div key={item} className="flex items-start gap-4 p-6 rounded-card border border-line bg-soft dark:bg-gray-800 dark:border-gray-700">
              <span className="flex-shrink-0 w-6 h-6 rounded-full bg-accent/10 flex items-center justify-center mt-0.5">
                <Check className="w-4 h-4 text-accent" />
              </span>
              <p className="text-dark dark:text-gray-200 leading-relaxed text-sm">{item}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
